import { render, staticRenderFns } from "./SignInAnswerChallenge.vue?vue&type=template&id=533c0d47&scoped=true"
import script from "./SignInAnswerChallenge.vue?vue&type=script&lang=js"
export * from "./SignInAnswerChallenge.vue?vue&type=script&lang=js"
import style0 from "./SignInAnswerChallenge.vue?vue&type=style&index=0&id=533c0d47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533c0d47",
  null
  
)

export default component.exports